import React from "react";
import { CallViewsSummary } from "../../../types/call-views.types";
import { formatNumber } from "../../../utils/formatters";

interface ChannelActionBreakdownProps {
  totalByChannelAction: CallViewsSummary["totalByChannelAction"];
}

const CHANNELS: { key: string; label: string }[] = [
  { key: "web", label: "Web" },
  { key: "api", label: "API" },
  { key: "email", label: "Email" },
];

const ACTIONS: { key: string; label: string }[] = [
  { key: "list", label: "Lista" },
  { key: "detail", label: "Pojedynczy nabór" },
];

export const ChannelActionBreakdown: React.FC<ChannelActionBreakdownProps> = ({
  totalByChannelAction,
}) => {
  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-6"
      data-testid="channel-action-breakdown"
      role="region"
      aria-label="Odsłony według kanału i typu akcji"
    >
      <h3 className="text-lg font-semibold text-neutral-900 mb-4">
        Odsłony wg kanału i akcji
      </h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-neutral-500 border-b border-neutral-200">
              <th scope="col" className="py-2 pr-4 font-medium">Kanał</th>
              {ACTIONS.map((action) => (
                <th key={action.key} scope="col" className="py-2 px-4 font-medium text-right">
                  {action.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {CHANNELS.map((channel) => {
              const row = totalByChannelAction[channel.key] ?? {};
              return (
                <tr
                  key={channel.key}
                  className="border-b border-neutral-100 last:border-0"
                  data-testid={`channel-row-${channel.key}`}
                >
                  <td className="py-2 pr-4 font-medium text-neutral-900">
                    {channel.label}
                  </td>
                  {ACTIONS.map((action) => (
                    <td
                      key={action.key}
                      className="py-2 px-4 text-right text-neutral-700 tabular-nums"
                      data-testid={`cell-${channel.key}-${action.key}`}
                    >
                      {formatNumber(row[action.key] ?? 0)}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChannelActionBreakdown;
